// power.pipe.ts
import { formatDistanceToNow } from 'date-fns';

import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'chatduration',
  pure: false,
})
export class ChatDurationPipe implements PipeTransform {
  transform(date: Date): string {
    if (date) {
      const res = formatDistanceToNow(new Date(date));
      return res;
    } else {
      return '';
    }
  }
}
